import XhrRequestHandler from "../../lib/XhrRequestHandler";

export interface ICountry{
    pais_id: string,
    pais_nombre: string,
    pais_activo: string
}

export class CountrySystem {
  private readonly base = "/paises";
  constructor(private requestHandler: XhrRequestHandler) {}

  async getDataCountries() {
    return await this.requestHandler.get<ICountry[]>(
      `${this.base}/get-list`
    );
  }
}